import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=2c4254c2"
import script from "./Section5.vue?vue&type=script&lang=js"
export * from "./Section5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports